import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme, paginationItemClasses } from '@mui/material';

export const MuiPagination: {
    defaultProps?: ComponentsProps['MuiPagination'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiPagination'];
    variants?: ComponentsVariants['MuiPagination'];
} = {
    defaultProps: {
        color: 'secondary',
        shape: 'circular',
        variant: 'text',
        size: 'large',
    },
    styleOverrides: {
        root: ({ theme }) => ({
            padding: theme.spacing(theme.tokens.spacing.none, theme.tokens.spacing.xxs),
        }),
        ul: {
            '> li::before': {
                display: 'none',
            },
        },
    },
};

export const MuiPaginationItem: {
    defaultProps?: ComponentsProps['MuiPaginationItem'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiPaginationItem'];
    variants?: ComponentsVariants['MuiPaginationItem'];
} = {
    defaultProps: {},
    styleOverrides: {
        root: ({ theme }) => ({
            margin: theme.spacing(theme.tokens.spacing.none, theme.tokens.spacing.xxs),
            [`&.${paginationItemClasses.disabled}, &.${paginationItemClasses.disabled}.${paginationItemClasses.selected}`]:
                {
                    opacity: '100%',
                    color: theme.palette.text.disabled,
                },
        }),
    },
};
